var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-items-center tw-justify-center tw-mt-2"},[_c('l-invite-form',{attrs:{"invite-token":_vm.inviteToken}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }